import type { FunctionComponent } from 'react';

import {
  ConfigWrapper,
  DesktopLayoutBoxed,
} from '@kanda-libs/ks-design-library';

import { Copyright, JobSidebar } from 'components';
import useHelpModal from 'components/HelpModal/useHelpModal';
import ApplyHeader from 'pages/StartApplication/components/ApplyHeader';

import { NoApplicableLoans, Rates } from './components';

interface DesktopCreditLineProps {
  isLoading: boolean;
  isSubmitting: boolean;
  hasApplicableLoans: boolean;
  selectNewRate: boolean;
}

const Desktop: FunctionComponent<DesktopCreditLineProps> = function ({
  isLoading,
  isSubmitting,
  hasApplicableLoans,
  selectNewRate,
}) {
  const { showHelpModal } = useHelpModal();
  return (
    <ConfigWrapper sidebar={JobSidebar}>
      <DesktopLayoutBoxed
        help={showHelpModal}
        backgroundLines
        sidebar
        layoutFooter={<Copyright />}
      >
        <div className="flex flex-col w-full h-full px-4 py-16">
          <div className="flex flex-col w-full mx-auto max-w-128">
            <ApplyHeader />
            {hasApplicableLoans ? (
              <Rates
                isLoading={isLoading}
                isSubmitting={isSubmitting}
                selectNewRate={selectNewRate}
              />
            ) : (
              <NoApplicableLoans />
            )}
          </div>
        </div>
      </DesktopLayoutBoxed>
    </ConfigWrapper>
  );
};

Desktop.displayName = 'Quote-Content-Desktop-view';

export default Desktop;
